import { PropsWithChildren } from 'react'
import classNames from 'classnames'

type Props = PropsWithChildren & {
  backgroundVariant?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  title: string
}

export default function Title({
  backgroundVariant = 0,
  title,
  children,
}: Props) {
  const backgrounds = [
    "bg-[url('~/src/pages/landing/title/background-1.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-2.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-3.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-4.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-5.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-6.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-7.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-8.jpg')]",
    "bg-[url('~/src/pages/landing/title/background-9.jpg')]",
  ]

  return (
    <div
      className={classNames(
        `bg-cover text-white`,
        backgrounds[backgroundVariant],
      )}
    >
      <div className="container mx-auto flex min-h-[12rem] flex-col justify-end px-4 py-8">
        <div className="lg:mx-auto lg:w-2/3 2xl:w-1/2">
          <h1 className="font-serif text-4xl font-bold">{title}</h1>
          {children}
        </div>
      </div>
    </div>
  )
}
